import FrontSonda from "@gcloud-npm/utils.monitoring.front-sonda";
import { CQ_ACTION_CODES, CQ_POTS } from '../../catalogConstants'
import { parsePrice } from '@bitComponents/unifiedComponents/Price';
import { PRODUCT_TYPES } from "../../utils/catalog";

/**
 * Normalizador que elimina la elección de migra de las posibles elecciones del
 * cliente en los grupos de elección en los que no se hayan elegido
 * @param {Array} secondaryOptionsObj Objeto con todas las opciones secundarias
 * del cliente
 * @param {string} productType Tipo de producto de la selección
 * @param {number} groupIndex Índice del grupo de elección que ha seleccionado
 * el cliente
 * @param {string} phoneNumber Número de la migra seleccionada por el cliente
 * @returns Devuelve las nuevas elecciones secundarias del cliente
 */
export const removeMigrationOptionsSelected = (secondaryOptionsObj, productType, groupIndex, phoneNumber, mainOptionSelected) => {
  const newSecondaryOptionsObj = JSON.parse(JSON.stringify(secondaryOptionsObj));

  if (newSecondaryOptionsObj
    && newSecondaryOptionsObj.secondaryOptions
    && newSecondaryOptionsObj.secondaryOptions[productType]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].choiceGroups) {
    const newChoiceGroups = [];

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].choiceGroups.forEach((choiceGroup, index) => {
      const newChoiceGroup = { ...choiceGroup };
      if (index !== groupIndex) {
        const migrationChoice = newChoiceGroup.customerQuoteItems.find(choice => choice.actionId === CQ_ACTION_CODES.MIGRATION);

        if (migrationChoice && migrationChoice.phoneOptions) {
          const migrationPhoneToRemove = migrationChoice.phoneOptions.find(phone => phone.value === phoneNumber);

          if (migrationPhoneToRemove) {
            const migrationPhoneToRemoveIndex = migrationChoice.phoneOptions.indexOf(migrationPhoneToRemove);

            migrationChoice.phoneOptions.splice(migrationPhoneToRemoveIndex, 1);
            if (migrationChoice.phoneOptions.length === 0){
              const migrationChoiceToRemoveIndex = newChoiceGroup.customerQuoteItems.indexOf(migrationChoice);
              newChoiceGroup.customerQuoteItems.splice(migrationChoiceToRemoveIndex,1);
            } else if (newSecondaryOptionsObj.secondaryOptionsSelected && migrationChoice.phoneOptions.length === 1) {
              const optionSelected = newSecondaryOptionsObj.secondaryOptionsSelected.find(optionSelected => optionSelected.actionId === CQ_ACTION_CODES.MIGRATION && optionSelected.groupIndex === index && !optionSelected.phoneNumber);
              if(optionSelected && migrationChoice.phoneOptions[0].value) {
                optionSelected.phoneNumber = migrationChoice.phoneOptions[0].value;
              }
            }
          }
        }
      }

      newChoiceGroups.push(newChoiceGroup);
    });

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].choiceGroups = newChoiceGroups;
  }

  if (newSecondaryOptionsObj
    && newSecondaryOptionsObj.secondaryOptions
    && newSecondaryOptionsObj.secondaryOptions[productType]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].keepGroups) {
    const newKeepGroups = [];

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].keepGroups.forEach((keepGroup, index) => {
      const newKeepGroup = { ...keepGroup };
      if (index !== groupIndex) {
        const keepChoice = newKeepGroup.customerQuoteItems.find(choice => (choice.actionId === CQ_ACTION_CODES.MIGRATION || choice.actionId === CQ_ACTION_CODES.KEEP));

        if (keepChoice) {
          const choicePhoneToRemove = keepChoice.phoneOptions.find(phone => phone.value === phoneNumber);

          if (choicePhoneToRemove) {
            const choicePhoneToRemoveIndex = keepChoice.phoneOptions.indexOf(choicePhoneToRemove);

            keepChoice.phoneOptions.splice(choicePhoneToRemoveIndex, 1);
            if (newSecondaryOptionsObj.secondaryOptionsSelected && keepChoice.phoneOptions.length === 1) {
              const optionSelected = newSecondaryOptionsObj.secondaryOptionsSelected.find(optionSelected => (optionSelected.actionId === CQ_ACTION_CODES.MIGRATION || optionSelected.actionId === CQ_ACTION_CODES.KEEP) && optionSelected.groupIndex === index && !optionSelected.phoneNumber);
              if(keepChoice.phoneOptions[0].value) {
                optionSelected.phoneNumber = keepChoice.phoneOptions[0].value;
              }
            }
          }
        }
      }

      newKeepGroups.push(newKeepGroup);
    });

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].keepGroups = newKeepGroups;
  }

  return newSecondaryOptionsObj;
};

/**
 * Normalizador que elimina la elección de migra de las posibles elecciones del
 * cliente en los grupos de elección en los que no se hayan elegido
 * @param {Array} secondaryOptionsObj Objeto con todas las opciones secundarias
 * del cliente
 * @param {string} productType Tipo de producto de la selección
 * @param {number} groupIndex Índice del grupo de elección que ha seleccionado
 * el cliente
 * @param {string} phoneNumber Número de la migra seleccionada por el cliente
 * @returns Devuelve las nuevas elecciones secundarias del cliente
 */
export const addMigrationOptionToElseOptions = (secondaryOptionsObj, productType, groupIndex, previousSelection, mainOptionSelected) => {
  const newSecondaryOptionsObj = JSON.parse(JSON.stringify(secondaryOptionsObj));

  if (newSecondaryOptionsObj
    && newSecondaryOptionsObj.secondaryOptions
    && newSecondaryOptionsObj.secondaryOptions[productType]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].choiceGroups) {
    const newChoiceGroups = [];

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].choiceGroups.forEach((choiceGroup, index) => {
      const newChoiceGroup = { ...choiceGroup };
      if (index !== groupIndex) {
        let newMigrationGroup = newChoiceGroup.customerQuoteItems.find(choice => choice.actionId === CQ_ACTION_CODES.MIGRATION);
        const newMigrationGroupIndex = newChoiceGroup.customerQuoteItems.indexOf(newMigrationGroup);

        if (!newMigrationGroup) {
          newMigrationGroup = {
            actionId: CQ_ACTION_CODES.MIGRATION,
            phoneOptions: [{
              label: previousSelection.phoneNumber,
              value: previousSelection.phoneNumber,
            }],
            description: newChoiceGroup.customerQuoteItems[0].description,
          };
          newChoiceGroup.customerQuoteItems.push(newMigrationGroup);
        } else {
          newMigrationGroup.phoneOptions.push({
            label: previousSelection.phoneNumber,
            value: previousSelection.phoneNumber,
          });
          newChoiceGroup.customerQuoteItems[newMigrationGroupIndex] = newMigrationGroup;
        }
      }

      newChoiceGroups.push(newChoiceGroup);
    });

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].choiceGroups = newChoiceGroups;
  }

  if (newSecondaryOptionsObj
    && newSecondaryOptionsObj.secondaryOptions
    && newSecondaryOptionsObj.secondaryOptions[productType]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected]
    && newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].keepGroups) {
    const newKeepGroups = [];

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].keepGroups.forEach((keepGroup, index) => {
      const newKeepGroup = { ...keepGroup };
      if (index !== groupIndex) {
        let newKeepChoiceGroup = newKeepGroup.customerQuoteItems.find(choice => (choice.actionId === CQ_ACTION_CODES.MIGRATION || choice.actionId === CQ_ACTION_CODES.KEEP));
        const newKeepChoiceGroupIndex = newKeepGroup.customerQuoteItems.indexOf(newKeepChoiceGroup);

        if (!newKeepChoiceGroup) {
          newKeepChoiceGroup = {
            actionId: previousSelection.actionId,
            phoneOptions: [{
              label: previousSelection.phoneNumber,
              value: previousSelection.phoneNumber,
            }],
            description: previousSelection.description,
          };
          newKeepGroup.customerQuoteItems.push(newKeepChoiceGroup);
        } else {
          newKeepChoiceGroup.phoneOptions.push({
            label: previousSelection.phoneNumber,
            value: previousSelection.phoneNumber,
          });
          newKeepGroup.customerQuoteItems[newKeepChoiceGroupIndex] = newKeepChoiceGroup;
        }
      }

      newKeepGroups.push(newKeepGroup);
    });

    newSecondaryOptionsObj.secondaryOptions[productType][mainOptionSelected].keepGroups = newKeepGroups;
  }

  return newSecondaryOptionsObj;
};

export const getCommitmentOptions = (components, swap) => {
  const options = [];
  let taxName = '';
  if (Array.isArray(components) && components.length > 0) {
    components.forEach((component) => {
      const { customerQuotePossibleActions } = component;
      if (
        Array.isArray(customerQuotePossibleActions)
        && customerQuotePossibleActions.length > 0
      ) {
        customerQuotePossibleActions.forEach((possibleAction) => {
          const { offeringTerms } = possibleAction;
          if (
            Array.isArray(offeringTerms)
            && offeringTerms.length > 1
          ) {
            const orderedOfferingTerms = offeringTerms.sort((offeringTermA, offeringTermB) => {
              const { duration: durationA } = offeringTermA;
              const { duration: durationB } = offeringTermB;

              if (durationA && durationB) {
                if (durationA.amount < durationB.amount) {
                  return 1;
                }

                if (durationA.amount > durationB.amount) {
                  return -1;
                }
              }

              return 0;
            });
            orderedOfferingTerms.forEach((offeringTerm) => {
              const {
                id, _default: defaultOption, price, duration,
              } = offeringTerm;
              if (price && price.recurringCharges && duration && duration.amount) {
                let additionalInfo = '';
                if(swap && id === CQ_POTS.COMMITMENT_POT["36_MONTHS"]){
                  additionalInfo = 'Movistar Swap'
                }
                options.push({
                  id,
                  defaultOption,
                  label: `${parsePrice(price.recurringCharges.finalPrice)} € en ${duration.amount} cuotas`,
                  additionalInfo,
                });
                if (!taxName) {
                  ({ taxName } = price);
                }
              }
            });
          }
        });
      }
      
    });
  }
  return { options, taxName };
};

export const getTermsAndConditions = (termsAndConditions) => {
  let legalConditionsString = '';
  if (
    termsAndConditions
    && Array.isArray(termsAndConditions)
    && termsAndConditions.length > 0
  ) {
    legalConditionsString += '<h1 class="termsAndConditionsTitle">Condiciones particulares y generales</h1>';
    termsAndConditions.forEach((legalHTML) => {
      legalConditionsString += `${legalHTML.file}\n`;
    });
  }
  return legalConditionsString;
};

export const shipmentTermFilter = (terms) => { // TODO trasladar lógica a SAGAS
  if (terms.length === 1) {
    return terms;
  }
  if (terms.length > 1) {
    const homeShipping = terms.find((term) => {
      return term.id === CQ_POTS.SHIPPING_POT.HOME_SHIPPING_ID;
    });
    if (homeShipping) {
      return [homeShipping];
    }
    const frontSonda = new FrontSonda({
      processName: "shipmentTermFilter",
      filePath: "reducers/normalizers/uiNeeds",
    });
    frontSonda.severalMessage({
      info: `Se han recibido los siguientes terms: ${terms}`,
    });
    return terms;
  }
  const frontSonda = new FrontSonda({
    processName: "shipmentTermFilter",
    filePath: "reducers/normalizers/uiNeeds",
  });
  frontSonda.severalMessage({
    info: `No se ha recibido ningun term: ${terms}`,
  });
  return terms;
};

export const normalizeProvisionalAgreementData = (agreementApplies, attachments) => {
  let provisionalAgreementData = null;
  if (agreementApplies && Array.isArray(attachments)) {
    provisionalAgreementData = [];
    attachments.forEach((document) => {
      const { content, name, url } = document;
      provisionalAgreementData.push({ content, name, url });
    });
  }
  return provisionalAgreementData;
};

/**
 * Fusiona un array de direcciones con otro array de direcciones mientras se asegura
 * de que no haya duplicados basados en la propiedad "locationId".
 *
 * @param {Array<object>} addressesArray - El array inicial de direcciones a fusionar.
 * @param {Array<object>} addressesToAdd - El array de direcciones para añadir.
 * @returns {Array<object>} - Un nuevo array que fusiona los dos arrays de direcciones sin duplicados de "locationId".
 */
export const addAddressesWithNoDuplicates = (addressesArray, addressesToAdd) => {
  const mergedArrays = [...addressesArray];

  addressesToAdd.forEach((address) => {
    const duplicatedObjIndex = mergedArrays.findIndex(item => item.locationId === address.locationId);

    if (duplicatedObjIndex === -1) {
      mergedArrays.push(address);
    } else if (address.locationId) {
      if(mergedArrays[duplicatedObjIndex].productType !== PRODUCT_TYPES.PACK){
        mergedArrays[duplicatedObjIndex] = address;
      }
    }
  });

  return mergedArrays;
};
